/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceRef,
  BalanceRefOptional,
  BalanceRefMetaI,
  BalanceRefTrackedI,
} from "./balance-ref";
import { BalanceRefTracked, BalanceRefMeta } from "./balance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceTransactionBase,
  BalanceTransactionBaseOptional,
  BalanceTransactionBaseMetaI,
  BalanceTransactionBaseTrackedI,
} from "./balance-transaction-base";
import {
  BalanceTransactionBaseTracked,
  BalanceTransactionBaseMeta,
} from "./balance-transaction-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceTransactionRef,
  BalanceTransactionRefOptional,
  BalanceTransactionRefMetaI,
  BalanceTransactionRefTrackedI,
} from "./balance-transaction-ref";
import {
  BalanceTransactionRefTracked,
  BalanceTransactionRefMeta,
} from "./balance-transaction-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceTransactionType,
  BalanceTransactionTypeOptional,
  BalanceTransactionTypeMetaI,
  BalanceTransactionTypeTrackedI,
} from "./balance-transaction-type";
import {
  BalanceTransactionTypeTracked,
  BalanceTransactionTypeMeta,
} from "./balance-transaction-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PurchasableState,
  PurchasableStateOptional,
  PurchasableStateMetaI,
  PurchasableStateTrackedI,
} from "./purchasable-state";
import {
  PurchasableStateTracked,
  PurchasableStateMeta,
} from "./purchasable-state";

/**
 *
 * @export
 * @interface BalanceTransactionFull
 */
export interface BalanceTransactionFullOptional extends BalanceTransactionBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof BalanceTransactionFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceTransactionFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionFull
   */
  assignId?: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof BalanceTransactionFull
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionFull
   */
  purchaseDate?: Date;
  /**
   *
   * @type {BalanceTransactionType}
   * @memberof BalanceTransactionFull
   */
  balanceTransactionType?: BalanceTransactionType;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionFull
   */
  transactionAmountCents?: number;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionFull
   */
  transactionDateTime?: Date;
  /**
   *
   * @type {BalanceRef}
   * @memberof BalanceTransactionFull
   */
  balanceId?: BalanceRefOptional;
}

export interface BalanceTransactionFull
  extends
    BalanceTransactionFullOptional,
    BalanceTransactionBase,
    BalanceTransactionRef,
    Deletable {
  /**
   *
   * @type {boolean}
   * @memberof BalanceTransactionFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceTransactionFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionFull
   */
  assignId: number;
  /**
   *
   * @type {PurchasableState}
   * @memberof BalanceTransactionFull
   */
  purchasableState?: PurchasableState;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionFull
   */
  purchaseDate?: Date;
  /**
   *
   * @type {BalanceTransactionType}
   * @memberof BalanceTransactionFull
   */
  balanceTransactionType?: BalanceTransactionType;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionFull
   */
  transactionAmountCents: number;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionFull
   */
  transactionDateTime?: Date;
  /**
   *
   * @type {BalanceRef}
   * @memberof BalanceTransactionFull
   */
  balanceId: BalanceRef;
}

export interface BalanceTransactionFullTrackedI extends BalanceTransactionBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof BalanceTransactionFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceTransactionFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {PurchasableState}
   * @memberof BalanceTransactionFull
   */
  purchasableState?: PurchasableState;
  purchasableStateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionFull
   */
  purchaseDate?: Date;
  purchaseDateIsSet: boolean;
  /**
   *
   * @type {BalanceTransactionType}
   * @memberof BalanceTransactionFull
   */
  balanceTransactionType?: BalanceTransactionType;
  balanceTransactionTypeIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceTransactionFull
   */
  transactionAmountCents?: number;
  transactionAmountCentsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceTransactionFull
   */
  transactionDateTime?: Date;
  transactionDateTimeIsSet: boolean;
  /**
   *
   * @type {BalanceRef}
   * @memberof BalanceTransactionFull
   */
  balanceId?: BalanceRefTrackedI;
  balanceIdIsSet: boolean;
}

transformDatesMap.set(
  "BalanceTransactionFull",
  function (model: BalanceTransactionFull) {
    if (typeof model.purchaseDate == "string")
      model.purchaseDate = new Date(model.purchaseDate);
    if (typeof model.transactionDateTime == "string")
      model.transactionDateTime = new Date(model.transactionDateTime);
    const transformDatesbalanceId = transformDatesMap.get("BalanceRef");
    if (transformDatesbalanceId && model.balanceId) {
      transformDatesbalanceId(model.balanceId);
    }
  },
);

export type BalanceTransactionFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  purchasableState: PropertyMeta<PurchasableStateMetaI>;
  //isDate: false
  //isDatetime: true
  purchaseDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  balanceTransactionType: PropertyMeta<BalanceTransactionTypeMetaI>;
  //isDate: false
  //isDatetime: false
  transactionAmountCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  transactionDateTime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  balanceId: PropertyMeta<BalanceRefMetaI>;
}>;

export var BalanceTransactionFullMeta: BalanceTransactionFullMetaI =
  {} as BalanceTransactionFullMetaI;
BalanceTransactionFullMeta = typeMeta("BalanceTransactionFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  purchasableState: propertyMeta(
    "purchasableState",
    false,
    false,
    false,
    PurchasableStateMeta,
  ),
  purchaseDate: propertyMeta(
    "purchaseDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  balanceTransactionType: propertyMeta(
    "balanceTransactionType",
    false,
    false,
    false,
    BalanceTransactionTypeMeta,
  ),
  transactionAmountCents: propertyMeta(
    "transactionAmountCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  transactionDateTime: propertyMeta(
    "transactionDateTime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  balanceId: propertyMeta("balanceId", false, true, false, BalanceRefMeta),
});

const metaI = BalanceTransactionFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([BalanceTransactionRefMeta]);
  metaI.assignId.inheritedFrom = BalanceTransactionRefMeta.assignId;
  metaI.interfaces = metaI.interfaces.concat([BalanceTransactionBaseMeta]);
  metaI.purchasableState.inheritedFrom =
    BalanceTransactionBaseMeta.purchasableState;
  metaI.purchaseDate.inheritedFrom = BalanceTransactionBaseMeta.purchaseDate;
  metaI.balanceTransactionType.inheritedFrom =
    BalanceTransactionBaseMeta.balanceTransactionType;
  metaI.transactionAmountCents.inheritedFrom =
    BalanceTransactionBaseMeta.transactionAmountCents;
  metaI.transactionDateTime.inheritedFrom =
    BalanceTransactionBaseMeta.transactionDateTime;
});

export class BalanceTransactionFullTracked
  extends BalanceTransactionBaseTracked
  implements BalanceTransactionFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  purchasableState__I?: PurchasableState = undefined;
  purchasableStateIsSet: boolean = false;
  set purchasableState(v: undefined | PurchasableState) {
    if (v !== undefined) {
      this.purchasableState__I = v;
      this.purchasableStateIsSet = true;
    } else {
      this.purchasableState__I = v || undefined;
      this.purchasableStateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchasableState() {
    return this.purchasableState__I;
  }
  purchaseDate__I?: Date = undefined;
  purchaseDateIsSet: boolean = false;
  set purchaseDate(v: undefined | Date) {
    if (v !== undefined) {
      this.purchaseDate__I = v;
      this.purchaseDateIsSet = true;
    } else {
      this.purchaseDate__I = v || undefined;
      this.purchaseDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get purchaseDate() {
    return this.purchaseDate__I;
  }
  balanceTransactionType__I?: BalanceTransactionType = undefined;
  balanceTransactionTypeIsSet: boolean = false;
  set balanceTransactionType(v: undefined | BalanceTransactionType) {
    if (v !== undefined) {
      this.balanceTransactionType__I = v;
      this.balanceTransactionTypeIsSet = true;
    } else {
      this.balanceTransactionType__I = v || undefined;
      this.balanceTransactionTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceTransactionType() {
    return this.balanceTransactionType__I;
  }
  transactionAmountCents__I?: number = undefined;
  transactionAmountCentsIsSet: boolean = false;
  set transactionAmountCents(v: undefined | number) {
    if (v !== undefined) {
      this.transactionAmountCents__I = v;
      this.transactionAmountCentsIsSet = true;
    } else {
      this.transactionAmountCents__I = v || undefined;
      this.transactionAmountCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get transactionAmountCents() {
    return this.transactionAmountCents__I;
  }
  transactionDateTime__I?: Date = undefined;
  transactionDateTimeIsSet: boolean = false;
  set transactionDateTime(v: undefined | Date) {
    if (v !== undefined) {
      this.transactionDateTime__I = v;
      this.transactionDateTimeIsSet = true;
    } else {
      this.transactionDateTime__I = v || undefined;
      this.transactionDateTimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get transactionDateTime() {
    return this.transactionDateTime__I;
  }
  balanceId__I?: BalanceRefTracked = undefined;
  balanceIdIsSet: boolean = false;
  set balanceId(v: undefined | BalanceRefTracked) {
    if (v !== undefined) {
      this.balanceId__I = v;
      this.balanceIdIsSet = true;
    } else {
      this.balanceId__I = v || undefined;
      this.balanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get balanceId() {
    return this.balanceId__I;
  }
  constructor(
    config?: BalanceTransactionFullOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.balanceId?.setIds();
  }
  assignFrom(
    config: BalanceTransactionFullOptional,
    options?: AssignOptions,
  ): BalanceTransactionFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.purchasableState &&
      this.purchasableStateApplyFilter(optionsRequired.filter)
    ) {
      this.purchasableState = config.purchasableState;
      if (optionsRequired.unassign) this.purchasableStateIsSet = false;
      else this.purchasableStateIsSet = true;
    }
    if (
      config.purchaseDate &&
      this.purchaseDateApplyFilter(optionsRequired.filter)
    ) {
      this.purchaseDate = config.purchaseDate;
      if (optionsRequired.unassign) this.purchaseDateIsSet = false;
      else this.purchaseDateIsSet = true;
    }
    if (
      config.balanceTransactionType &&
      this.balanceTransactionTypeApplyFilter(optionsRequired.filter)
    ) {
      this.balanceTransactionType = config.balanceTransactionType;
      if (optionsRequired.unassign) this.balanceTransactionTypeIsSet = false;
      else this.balanceTransactionTypeIsSet = true;
    }
    if (
      config.transactionAmountCents &&
      this.transactionAmountCentsApplyFilter(optionsRequired.filter)
    ) {
      this.transactionAmountCents = config.transactionAmountCents;
      if (optionsRequired.unassign) this.transactionAmountCentsIsSet = false;
      else this.transactionAmountCentsIsSet = true;
    }
    if (
      config.transactionDateTime &&
      this.transactionDateTimeApplyFilter(optionsRequired.filter)
    ) {
      this.transactionDateTime = config.transactionDateTime;
      if (optionsRequired.unassign) this.transactionDateTimeIsSet = false;
      else this.transactionDateTimeIsSet = true;
    }
    if (config.balanceId && this.balanceIdApplyFilter(optionsRequired.filter)) {
      this.balanceId = new BalanceRefTracked(config.balanceId, options);
      if (optionsRequired.unassign) this.balanceIdIsSet = false;
      else this.balanceIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): BalanceTransactionFullTrackedI {
    const cloned = {} as BalanceTransactionFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.purchasableStateIsSetDeep() &&
      this.purchasableStateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchasableStateIsSet = true;
      cloned.purchasableState = this.purchasableState;
    } else {
      //cloned.purchasableStateIsSet = false
    }
    if (
      this.purchaseDateIsSetDeep() &&
      this.purchaseDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.purchaseDateIsSet = true;
      cloned.purchaseDate = this.purchaseDate;
    } else {
      //cloned.purchaseDateIsSet = false
    }
    if (
      this.balanceTransactionTypeIsSetDeep() &&
      this.balanceTransactionTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTransactionTypeIsSet = true;
      cloned.balanceTransactionType = this.balanceTransactionType;
    } else {
      //cloned.balanceTransactionTypeIsSet = false
    }
    if (
      this.transactionAmountCentsIsSetDeep() &&
      this.transactionAmountCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionAmountCentsIsSet = true;
      cloned.transactionAmountCents = this.transactionAmountCents;
    } else {
      //cloned.transactionAmountCentsIsSet = false
    }
    if (
      this.transactionDateTimeIsSetDeep() &&
      this.transactionDateTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.transactionDateTimeIsSet = true;
      cloned.transactionDateTime = this.transactionDateTime;
    } else {
      //cloned.transactionDateTimeIsSet = false
    }
    if (
      this.balanceIdIsSetDeep() &&
      this.balanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceIdIsSet = true;
      cloned.balanceId = this.balanceId?.removeUnset(filter);
    } else {
      //cloned.balanceIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): BalanceTransactionFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.purchasableStateApplyFilter(filter))
      this.purchasableStateIsSet = false;

    if (!this.purchaseDateApplyFilter(filter)) this.purchaseDateIsSet = false;

    if (!this.balanceTransactionTypeApplyFilter(filter))
      this.balanceTransactionTypeIsSet = false;

    if (!this.transactionAmountCentsApplyFilter(filter))
      this.transactionAmountCentsIsSet = false;

    if (!this.transactionDateTimeApplyFilter(filter))
      this.transactionDateTimeIsSet = false;

    if (!this.balanceIdApplyFilter(filter)) this.balanceIdIsSet = false;
    this.balanceId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.isDeleted,
      BalanceTransactionFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.isNew,
      BalanceTransactionFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.assignId,
      BalanceTransactionFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  purchasableStateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.purchasableState,
      BalanceTransactionFullMeta,
      this.purchasableState,
      this,
    );
  }
  purchasableStateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchasableStateIsSet && this.purchasableStateApplyFilter(filter))
      return true;

    return false;
  }
  purchaseDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.purchaseDate,
      BalanceTransactionFullMeta,
      this.purchaseDate,
      this,
    );
  }
  purchaseDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.purchaseDateIsSet && this.purchaseDateApplyFilter(filter))
      return true;

    return false;
  }
  balanceTransactionTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.balanceTransactionType,
      BalanceTransactionFullMeta,
      this.balanceTransactionType,
      this,
    );
  }
  balanceTransactionTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceTransactionTypeIsSet &&
      this.balanceTransactionTypeApplyFilter(filter)
    )
      return true;

    return false;
  }
  transactionAmountCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.transactionAmountCents,
      BalanceTransactionFullMeta,
      this.transactionAmountCents,
      this,
    );
  }
  transactionAmountCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionAmountCentsIsSet &&
      this.transactionAmountCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  transactionDateTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.transactionDateTime,
      BalanceTransactionFullMeta,
      this.transactionDateTime,
      this,
    );
  }
  transactionDateTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.transactionDateTimeIsSet &&
      this.transactionDateTimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceTransactionFullMeta.balanceId,
      BalanceTransactionFullMeta,
      this.balanceId,
      this,
    );
  }
  balanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceIdIsSet && this.balanceIdApplyFilter(filter)) return true;
    return this.balanceId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.purchasableStateIsSetDeep(filter)) return true;
    if (this.purchaseDateIsSetDeep(filter)) return true;
    if (this.balanceTransactionTypeIsSetDeep(filter)) return true;
    if (this.transactionAmountCentsIsSetDeep(filter)) return true;
    if (this.transactionDateTimeIsSetDeep(filter)) return true;
    if (this.balanceIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
